import UserDisplay from "./UserDisplay";
import UserAvatar from "./UserAvatar";

export { UserAvatar };
export default UserDisplay;
